// extracted by mini-css-extract-plugin
module.exports = {"item":"_4ed38554","favorites":"_8f030a66","favoritesWrapper":"_504175d5","favoritesIconWrapper":"_54a5dcbe"};